import apiClient from "@/app/api/client";
import { plantsEndpoints } from "@/app/api/endpoints";
import type { PlantListParams, PlantPaginatedResponse } from "../types";

// Minimal, org-scoped plant source for the contract form Select.
// There is no dedicated frontend plants module yet; this covers the FK selector.
export const plantService = {
	async list(params?: PlantListParams): Promise<PlantPaginatedResponse> {
		const response = await apiClient.get<PlantPaginatedResponse>(plantsEndpoints.list, {
			params,
		});
		return response.data;
	},
};
